var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Messages'),_c('div',{staticClass:"d-flex flex-column align-center justify-center",staticStyle:{"height":"100%"}},[_c('Loader'),_c('span',[_vm._v(_vm._s(_vm.$store.getters.globalLoadingHint))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }